/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeTypeItem } from '../../models/company-office-type-item';
import { CompanyOfficeTypeUpdateDto } from '../../models/company-office-type-update-dto';

export interface OfficeControllerUpdateOfficeType$Params {
  id: number;
      body: CompanyOfficeTypeUpdateDto
}

export function officeControllerUpdateOfficeType(http: HttpClient, rootUrl: string, params: OfficeControllerUpdateOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerUpdateOfficeType.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeTypeItem;
      }>;
    })
  );
}

officeControllerUpdateOfficeType.PATH = '/company/office/type/{id}';
